import { z } from 'zod';

export const providerTypeSchema = z.enum([
  'resend',
  'sendgrid',
  'postmark',
  'mailgun',
  'ses',
  'smtp_generic',
]);

export const providerConnectionSchema = z.object({
  id: z.string().uuid(),
  providerType: providerTypeSchema,
  displayName: z.string(),
  verifiedAt: z.string().datetime().nullable(),
  lastHealthCheckAt: z.string().datetime().nullable(),
  healthStatus: z.enum(['healthy', 'degraded', 'down', 'unknown']).default('unknown'),
  isDefault: z.boolean().default(false),
});

export const createProviderResendSchema = z.object({
  providerType: z.literal('resend'),
  displayName: z.string().min(1).max(80),
  apiKey: z.string().min(16),
});

export const createProviderSendgridSchema = z.object({
  providerType: z.literal('sendgrid'),
  displayName: z.string().min(1).max(80),
  apiKey: z.string().min(16),
});

export const createProviderPostmarkSchema = z.object({
  providerType: z.literal('postmark'),
  displayName: z.string().min(1).max(80),
  serverToken: z.string().min(16),
});

export const createProviderMailgunSchema = z.object({
  providerType: z.literal('mailgun'),
  displayName: z.string().min(1).max(80),
  apiKey: z.string().min(16),
  domain: z.string().min(3),
  region: z.enum(['us', 'eu']).default('us'),
});

export const createProviderSesSchema = z.object({
  providerType: z.literal('ses'),
  displayName: z.string().min(1).max(80),
  accessKeyId: z.string().min(16),
  secretAccessKey: z.string().min(16),
  region: z.string(),
});

export const createProviderSmtpSchema = z.object({
  providerType: z.literal('smtp_generic'),
  displayName: z.string().min(1).max(80),
  host: z.string().min(3),
  port: z.number().int().min(1).max(65535),
  username: z.string().min(1),
  password: z.string().min(1),
  secure: z.boolean().default(true),
});

export const createProviderSchema = z.discriminatedUnion('providerType', [
  createProviderResendSchema,
  createProviderSendgridSchema,
  createProviderPostmarkSchema,
  createProviderMailgunSchema,
  createProviderSesSchema,
  createProviderSmtpSchema,
]);

export type ProviderType = z.infer<typeof providerTypeSchema>;
export type ProviderConnection = z.infer<typeof providerConnectionSchema>;
export type CreateProviderInput = z.infer<typeof createProviderSchema>;
